import { ChangeDetectionStrategy, Component, computed, inject, signal } from '@angular/core';
import { Roles } from '@models/roles.models';
import { APP_ROUTES, REQUESTS_ROLES } from '@routes';
import { EytcAuthService } from '@services/index';
import { AgRendererComponent } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { LinkColumnComponent } from '../link-column/link-column.component';

@Component({
  selector: 'app-request-id-column',
  standalone: true,
  imports: [LinkColumnComponent],
  templateUrl: './request-id-column.component.html',
  styleUrl: './request-id-column.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RequestIdColumnComponent implements AgRendererComponent {
  readonly #authService = inject(EytcAuthService);

  readonly requestEntityId = signal<string>('');
  readonly requestId = signal<string>('');
  readonly requesterEntityId = signal<string | null>('');
  readonly newTab = signal<boolean>(false);

  readonly currentUserIsOwner = computed(() => {
    return this.requesterEntityId() === this.#authService.userProfile()?.id;
  });

  readonly currentUserIsCustomsBroker = computed(() => {
    return this.#authService.userRoles().includes(Roles.CUSTOMS_BROKER);
  });

  readonly allowLink = computed(() => {
    const allowedRoles = REQUESTS_ROLES.filter(role => role !== Roles.CUSTOMS_BROKER);
    return (
      (this.currentUserIsCustomsBroker() && this.currentUserIsOwner()) ||
      this.#authService.userRoles().some(role => allowedRoles.includes(role))
    );
  });

  readonly routerLink = computed(() => {
    return ['/app/', APP_ROUTES.REQUESTS, APP_ROUTES.CLASSIFICATION, this.requestEntityId(), this.requestId()];
  });

  agInit(params: ICellRendererParams): void {
    this.requestEntityId.set(params.data.requestEntityId);
    this.requestId.set(params.data.requestId);
    this.requesterEntityId.set(params.data.requesterEntityId);

    if (params.colDef?.cellRendererParams?.newTab) {
      this.newTab.set(true);
    }
  }

  refresh(params: ICellRendererParams): boolean {
    this.agInit(params);
    return true;
  }
}
